import { useQuery } from '@tanstack/react-query';
import { ApiError, IState } from 'utils/types';
import axios from 'axios';

import c from '../utils/constants';

interface Result {
  data: IState[];
}

export default function useGetStates(params: {
  countryCode: string;
  keyword?: string;
}) {
  return useQuery<IState[], ApiError>({
    queryKey: [c.STATES, params],
    queryFn: async () => {
      const { countryCode, ...rest } = params;

      const request = await axios.get<Result>(
        `${import.meta.env.VITE_APP_END_POINT}/api/v1/common/countries/${countryCode}/states/`,
        {
          params: rest,
          headers: {
            Authorization: import.meta.env.VITE_APP_BASIC_AUTH,
          },
        },
      );
      return request.data.data;
    },
  });
}
